
const standaloneToast = (
  _props: {
    status: 'success' | 'error' | 'warning' | 'info';
    title: string;
    description?: string;
    duration?: number;
  },
): null => {
  return null;
};

export default standaloneToast;
